<template>
  <el-form-item
    :label="label"
    class="phone-number"
    :prop="prop"
    :rules="rules"
  >
    <el-input
      v-model="phoneNumber"
      type="text"
      :clearable="true"
      :maxlength="15"
      resize="none"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '電話番号'
    },
    prop: {
      type: String,
      default: 'phone_number'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '前方一致' : '半角数字（ハイフンなし）'
    }
  },
  computed: {
    phoneNumber: {
      get () {
        return this.value
      },
      set (phoneNumber) {
        this.$emit('input', phoneNumber)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
          rules.push(this.validatorTel(this.label, 'blur'))
        }
        return rules
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.el-form-item {
  &.phone-number {
    .el-form-item__content {
        width: 16em;
    }
  }
}
</style>
